import {styled} from "@mui/material/styles";
import {Button} from "@mui/material";

const SecondaryButton = styled(Button)(({ theme }) => ({
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: '4px 24px',
    textTransform: 'uppercase',
    letterSpacing: '1.2px',
    fontWeight: 600,
    display: 'block',
    width: '150px',
    '&:hover': {
        backgroundColor: theme.palette.primary.dark
    }
}));

export default SecondaryButton;